let formatLong = [
  " thousand",
  " million",
  " billion",
  " trillion",
  " quadrillion",
  " quintillion",
  " sextillion",
  " septillion",
  " octillion",
  " nonillion",
];
let prefixes = [
  "",
  "un",
  "duo",
  "tre",
  "quattuor",
  "quin",
  "sex",
  "septen",
  "octo",
  "novem",
];
let suffixes = [
  "decillion",
  "vigintillion",
  "trigintillion",
  "quadragintillion",
  "quinquagintillion",
  "sexagintillion",
  "septuagintillion",
  "octogintillion",
  "nonagintillion",
];
for (let i in suffixes) {
  for (let ii in prefixes) {
    formatLong.push(" " + prefixes[ii] + suffixes[i]);
  }
}
console.log("lol:", formatLong);

module.exports = (num) => {
  let ognum = num;
  if (!isFinite(num)) {
    return "Infinity";
  }
  let base = 0;
  let notVal = "";
  if (num >= 1_000_000) {
    num /= 1000;
    while (Math.round(num) >= 1000) {
      num /= 1000;
      base++;
    }
    if (base >= formatLong) {
      return "Basicly a lot...";
    } else {
      notVal = formatLong[base];
    }
  }
  let temp = Math.round(num * 1000) / 1000;
  return (ognum * 1000 >= 1_000_000 ? temp : Math.round(temp)) + notVal;
};
